import React from 'react';
import Chatbot from './Chatbot'; // <--- IMPORTANT : On importe le Chatbot ici

function TeamShowcase() {
  const squad = [
    {
      name: "Rockssan Hounton",
      role: "Lead Architect / Backend",
      skills: ["Supabase Core", "React JS", "Security Ops"],
      status: "ONLINE 🟢",
      portfolioLink: "https://portfoliorockssanhounton.vercel.app" 
    },
    {
      name: "Junior Useni",
      role: "Fullstack Engineer",
      skills: ["Algorithmics", "API Integration", "System Logic"],
      status: "READY 🟢",
      portfolioLink: null
    },
    {
      name: "Yacine Maacha",
      role: "UI/UX Designer & Dev",
      skills: ["Creative Interface", "CSS Animation", "User Flow"],
      status: "READY 🟢",
      portfolioLink: null
    },
    {
      name: "Aiman Gamine",
      role: "Frontend Specialist",
      skills: ["Responsive Design", "Optimization", "React Components"],
      status: "READY 🟢",
      portfolioLink: null
    }
  ];

  return (
    <div className="App">
      {/* Fond et Effets */}
      <div className="logo-background"></div>
      <div className="hex-overlay"></div>
      <div className="scanline"></div>

      <header>
        <h1 className="cyber-title">DISTRICT ZONE 25</h1>
        <div className="subtitle">UNITÉ DE DÉVELOPPEMENT</div>
        <div className="ndi-badge">MISSION : NUIT DE L'INFO 2025</div>
      </header>

      <section style={{ maxWidth: '800px', padding: '0 20px' }}>
        <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#ccc' }}>
          Nous sommes un collectif de développeurs prêts à relever le défi. 
          Notre force réside dans notre cohésion et notre maîtrise des technologies modernes. 
          Le code est notre arme, l'innovation est notre cible.
        </p>
      </section>

      <section style={{ width: '100%' }}>
        <h2 style={{ color: '#fff', marginTop: '60px', textTransform: 'uppercase', letterSpacing: '3px', fontSize: '2rem' }}>
          L'ESCOUADE
        </h2>
        
        <div className="squad-container">
          {squad.map((member, index) => (
            <div key={index} className="member-card">
              
              {member.portfolioLink ? (
                <a 
                  href={member.portfolioLink} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div className="member-name">{member.name}</div>
                </a>
              ) : (
                <div className="member-name">{member.name}</div>
              )}
              
              <div className="member-role">{member.role}</div>
              <div className="member-stats">
                <div style={{color: '#00f0ff', fontWeight: 'bold', marginBottom: '5px', fontSize: '0.8rem'}}>
                  COMPÉTENCES
                </div>
                <ul>
                  {member.skills.map((skill, i) => (
                    <li key={i}>{skill}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* --- C'EST ICI QUE LE CHATBOT EST AFFICHÉ --- */}
      <section style={{ marginTop: '50px', marginBottom: '50px' }}>
        <Chatbot />
      </section>

      <footer>
        <button className="join-btn" onClick={() => alert("Connexion au serveur District 25...")}>
          Contacter l'équipe
        </button>
        <p>
          © 2025 DISTRICT ZONE 25 • NUIT DE L'INFO
        </p>
      </footer>
    </div>
  );
}

export default TeamShowcase;